module.exports = __webpack_public_path__ + "img/fog.efd2aab0.svg";